module.exports = __webpack_public_path__ + "af2c973fdbd05d60024f7773528b5afa.ttf";